module.exports = __webpack_public_path__ + "assets/img/targeting-low.404eddbb.svg";